export var DataStoreKind;
(function (DataStoreKind) {
    DataStoreKind["S3"] = "S3DataStore";
    DataStoreKind["HTTP_LINK"] = "HttpLinkDataStore";
})(DataStoreKind || (DataStoreKind = {}));
export var DataStoreRekeyState;
(function (DataStoreRekeyState) {
    DataStoreRekeyState["NO_REKEY"] = "no_rekey";
    DataStoreRekeyState["IN_PROGRESS"] = "in_progress";
})(DataStoreRekeyState || (DataStoreRekeyState = {}));
